import $ from "jquery"

$(require("../apps/home/client/index.coffee").init)
